import React, { Fragment } from 'react'
import classNames from 'classnames'

import style from './PaginationPage.module.css'

function PaginationPage({
  pageNumber,
  onPageChanged,
  isSelected,
  text = pageNumber,
  type,
  icon,
  testId,
  title,
  ariaLabel,
  ariaSelected,
  tabIndex,
  handleKeyDown,
  id
}) {
  return (
    <li
      data-testid={testId}
      key={pageNumber}
      className={classNames(
        style.container,
        type !== 'primary' && isSelected && style.selected,
        type === 'primary' && isSelected && style.primary_selected
      )}
      onClick={() => onPageChanged(pageNumber)}
      title={title}
      aria-label={ariaLabel}
      id={id}
      aria-labelledby={id}
      aria-selected={ariaSelected}
      tabIndex={tabIndex}
      onKeyDown={(e) => handleKeyDown(e, pageNumber)}
      role='option'
    >
      {icon && <Fragment>{icon}</Fragment>}
      {!icon && <Fragment>{text}</Fragment>}
    </li>
  )
}

export default PaginationPage
